/* eslint-disable @typescript-eslint/no-explicit-any */

export default function <T extends object>(char: string, subject: T): T {
  return Object.keys(subject).reduce(
    (acc, cur) => ({
      ...acc,
      [cur.replaceAll(char, '')]: (subject as any)[cur]
    }),
    {}
  ) as T
}
